export const CONTACT_FIELD_NAMES = [
  "full_name_cont",
  "email_cont",
  "phone_number_cont",
  "street_address_cont",
  "suburb_cont",
  "postal_code_cont",
  "state_cont",
  "abn_cont",
  "company_name_cont",
];

export const CONTACT_SCHEMAS = [
    { name: "full_name_cont", label: "Full Name", required: true, type: "text", isMandatory: true, fieldTypeId: 1 },
    { name: "email_cont", label: "Email", required: false, type: "email", fieldTypeId: 8 },
    { name: "phone_number_cont", label: "Phone Number", required: false, type: "tel", isMandatory: false, fieldTypeId: 10 },
    { name: "street_address_cont", label: "Street Address", required: false, type: "text", fieldTypeId: 1 },
    { name: "suburb_cont", label: "Suburb", required: false, type: "text", fieldTypeId: 7 },
    { name: "postal_code_cont", label: "Postal Code", required: false, type: "text", fieldTypeId: 1 },
    { name: "state_cont", label: "State", required: false, type: "text", fieldTypeId: 1 },
    { name: "abn_cont", label: "ABN", required: false, type: "text", fieldTypeId: 1 },
    { name: "company_name_cont", label: "Company Name", required: false, type: "text", fieldTypeId: 1 },
  ];